import React from "react";
import { useLang } from "@/context/LanguageContext";
import { X, ShieldCheck, KeyRound } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const LoginModal = ({ open, onClose, redirectTo = "/", onDemo }) => {
  const { t } = useLang();
  if (!open) return null;

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + (redirectTo || "/");
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      data-testid="login-modal-backdrop"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-fade-up"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        data-testid="login-modal"
        className="card-gc max-w-md w-full p-6 sm:p-8 relative bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          data-testid="login-modal-close"
          className="absolute top-3 right-3 w-9 h-9 rounded-full text-stone-500 hover:bg-stone-100 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="flex flex-col items-center text-center mb-5">
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_site-framework-8/artifacts/u4lqn226_1780408844558.png"
            alt="Garlic Capital"
            className="h-16 w-auto object-contain mb-3"
          />
          <h2 className="text-2xl font-bold text-stone-900">{t.auth.login_title}</h2>
          <p className="text-stone-600 text-sm mt-1">Sign in to access this section.</p>
        </div>

        <button
          data-testid="modal-google-signin-btn"
          onClick={handleGoogle}
          className="w-full h-12 rounded-xl border-2 border-stone-300 bg-white text-stone-800 font-semibold flex items-center justify-center gap-3 hover:border-[#1E4D2B] hover:bg-stone-50 transition-all active:scale-[0.99]"
        >
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.1 8 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.6 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8L6.2 33C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.6l6.2 5.2c-.4.4 6.6-4.8 6.6-14.8 0-1.3-.1-2.4-.4-3.5z"/>
          </svg>
          <span>{t.auth.continue_google}</span>
        </button>

        <div className="mt-4 flex items-start gap-2 text-xs text-stone-500 leading-relaxed">
          <ShieldCheck size={14} className="flex-shrink-0 mt-0.5 text-[#1E4D2B]" />
          <span>{t.auth.privacy_note}</span>
        </div>

        {onDemo && (
          <>
            <div className="my-4 flex items-center gap-2 text-[10px] uppercase tracking-wider text-stone-400 font-semibold">
              <div className="flex-1 h-px bg-stone-200" />
              or
              <div className="flex-1 h-px bg-stone-200" />
            </div>
            <button
              data-testid="modal-demo-btn"
              onClick={onDemo}
              className="w-full h-11 rounded-xl bg-stone-100 hover:bg-stone-200 border border-stone-300 text-stone-700 text-sm font-semibold flex items-center justify-center gap-2 transition-colors"
            >
              <KeyRound size={15} /> Demo Login (Developer)
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginModal;
